import { DataGrid } from '@mui/x-data-grid'
import React, { useCallback } from 'react'
import '../../css/admin.css'
import '../../css/common.css'
import { useState } from 'react';
import PersonAddAlt1RoundedIcon from '@mui/icons-material/PersonAddAlt1Rounded';
import RemoveCircleRoundedIcon from '@mui/icons-material/RemoveCircleRounded';
import ModeRoundedIcon from '@mui/icons-material/ModeRounded';
import BreadCrumbBar from '../../common/breadCrumbBar/BreadCrumbBar';
import { useEffect } from 'react';
import { ApiService } from '../../services/apiService';
import { RoleData } from '../../common';
import { Button, DialogContentText, TextField, DialogTitle, Autocomplete, DialogContent, DialogActions, Dialog, CircularProgress } from '@mui/material';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import Warning from '../../common/alert/Warning';
import Delete from '../../common/alert/Delete';

const theme = createTheme();

export default function AdminList() {
	const [data, setData] = useState([]);
	const [no, setNo] = useState(0);
	const [userId, setUserId] = useState('');
	const [password, setpassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [authList, setAuthList] = useState([]);
	const [open, setOpen] = useState(false);
	const [openWarning, setOpenWarning] = useState(false);
	const [errorMsg, setErrorMsg] = useState('');
	const [alertOpen, setAlertOpen] = useState(false);
	const [modify, setModify] = useState(false);
	const [clickItem, setClickItem] = useState('');
	const [loading, setLoading] = useState(false);
	const authData = useSelector(state => state.auth);
	const role = authData.user.role.includes("admin");
	let adminData = {};

	const columns = [
		{
			field: 'email',
			headerName: '아이디',
			minWidth: 400,
			flex: 2,
		},
		{
			field: 'role',
			headerName: '권한',
			minWidth: 400,
			flex: 2,
			renderCell: (params) => {
				const selectData = RoleData.filter( data => params.value.includes(data.value)).map((item) => { return item.label + ', '}); 
				return(
					<>
						<p>{selectData}</p>
					</>
				)
			}
		},
		{
			field: 'modify',
			headerName: '수정',
			minWidth: 150,
			flex: 0.3,
			// width: 150,
			renderCell: (params) => {
				return(
					<>
						<button className="adminListEdit" onClick={() => editAdmin(params.row)}><ModeRoundedIcon sx={{pr:1, verticalAlign: "-1px", fontSize: "15px"}}/>수정</button>
					</>
				)
			}
		},
		{
			field: 'delete',
			headerName: '삭제',
			minWidth: 150,
			flex: 0.3,
			// width: 150,
			renderCell: (params) => {
				return(
					<>
						<button className="deleteBtn" onClick={() => alertOpenHandle(params.row.id)}><RemoveCircleRoundedIcon sx={{pr:1, verticalAlign: "-1px", fontSize: "15px"}}/>삭제</button>
					</>
				)
			}
		},
	];

	const closeWarning = (data) => {
		setOpenWarning(data);
	}

	const handleOpen = () => {
		setOpen(true);
		setUserId('');
		setpassword('');
		setConfirmPassword('');
		setAuthList([]);
		setModify(false);
	}

	const closeHandle = () => {
		setUserId('');
		setpassword('');
		setConfirmPassword('');
		setAuthList([]);
		setOpen(false);
		// setModify(false);
	}

	const handleChangeUserId = (event) => {
		setUserId(event.target.value);
	};

	const handleChangePassword = (event) => {
		setpassword(event.target.value);
	};

	const handleChangeConfirmPassword = (event) => {
		setConfirmPassword(event.target.value);
	};

	const alertOpenHandle = (id) => {
		setAlertOpen(true);
		setClickItem(id);
	}

	const alertCloseHandle = () => {
		setAlertOpen(false);
		setClickItem('');
	}

	const getData = async () => {
		try {
			setLoading(true);
			const adminListData = await ApiService.getAdminList();
			setData(adminListData.data.datas);
		} catch(error) {
			console.log('adminList - getData - error ::', error);
		} finally {
			setLoading(false);
		}
	}

	useEffect(() => {
		getData();
	},[]);

	const validCheck = (type) => {
		const emailRegex = /([\w-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
		
		const passwordTest = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^*+=-])(?!.*[^!@#$%^*+=-]).{10,}$/
		const passwordRex = /^(?=.*[a-zA-Z])(?=.*[-_!@#$%^*+=])(?=.*[0-9])(?!.*[^-_!@#$%^*+=0-9a-zA-Z]).{10,}$/;

		const continueCheck = (pwd) => {
			let o = 0;
			let d = 0;
			let p = 0;
			let n = 0;  
			let limit = 3;
			
			for(let i = 0; i < pwd.length; i++) {
				const tempVal = pwd.charAt(i);
				if(i > 0 && (p = o - tempVal) > -2 && (n = p === d ? n + 1 :0) > limit -3) {
					return true;
				}
				d = p;
				o = tempVal;
			}
			return false;
		}
		
		if(type === "insert") {
			if(userId === "") {
				setOpenWarning(true);
				setErrorMsg('아이디를 입력해주세요!');
				return false;
			}

			if(!emailRegex.test(userId)) {
				setOpenWarning(true);
				setErrorMsg('올바르지 않은 이메일 형식입니다!');
				return false;
			}
			
			if((password === '') && (confirmPassword === '')) {
				setOpenWarning(true);
				setErrorMsg('비밀번호를 입력하세요!');
				return false;
			}

			if((password !== '') || (confirmPassword !== '')) {
				if(password !== confirmPassword) {
					setOpenWarning(true);
					setErrorMsg('입력한 비밀번호가 서로 다릅니다!');
					return false;
				}

				if (!passwordRex.test(password)) {
					setOpenWarning(true);
					setErrorMsg('비밀번호는 영문, 특수문자(!@#$%^*+=_-), 숫자 조합으로 10자 이상이어야 합니다!');
					return false;
				}

				if(continueCheck(password)) {
					setOpenWarning(true);
					setErrorMsg('3개 이상 연속된 숫자는 입력할 수 없습니다!');
					return false;
				}
			}

		} else {
			if(password !== confirmPassword) {
				setOpenWarning(true);
				setErrorMsg('입력한 비밀번호가 서로 다릅니다!');
				return false;
			}

			if (!passwordRex.test(password)) {
				setOpenWarning(true);
				setErrorMsg('비밀번호는 영문, 특수문자(!@#$%^*+=_-), 숫자 조합으로 10자 이상이어야 합니다!');
				return false;
			}

			if(continueCheck(password)) {
				setOpenWarning(true);
				setErrorMsg('3개 이상 연속된 숫자는 입력할 수 없습니다!');
				return false;
			}

		}
		
		return true;
	}

	const handleInsert = async () => {
		const selectData = RoleData.filter(data => authList.includes(data.label)).map((item) => {
			return item.value
		});

		if(validCheck("insert")) {
			adminData = {
				"email": userId,
				"password": password,
				"confirmPassword": confirmPassword,
				"role": selectData
			};

			try {
				await ApiService.insertAdmin(adminData);
			} catch (error) {
				console.log('AdminList - handleInsert - error ::', error)
				setOpenWarning(true);
				setErrorMsg(error.response.data.message);
			} finally {
				closeHandle();
				getData();
			}
		}
	}

	const editAdmin = (row) => {
		setOpen(true);
		setModify(true);
		setUserId(row.email);
		setNo(row.id);

		const selectData = RoleData.filter( data => row.role.includes(data.value)).map((item) => { return item.label}); 
		setAuthList(selectData);
	}

	const handleEdit = async () => {

		const selectData = RoleData.filter(data => authList.includes(data.label)).map((item) => {
			return item.value
		});
		const id = no;

		//비밀번호를 수정했을 경우
		if ( password !== "" || confirmPassword !== "") {
			if(validCheck("edit")) {
				adminData = {
					"password": password,
					"confirmPassword": confirmPassword,
					"role": selectData
				};
				try {
					await ApiService.modifyAdmin(adminData, id);
					closeHandle();
				} catch(error) {
					console.log('AdminList - handleEditPw - error :: ', error)
					setOpenWarning(true);
					setErrorMsg(error.response.data.message);
				} finally {
					getData();
				}
			}
		} 
		
		if ( password === "" && confirmPassword === "" ) { //비밀번호를 수정하지 않고 권한만 수정한 경우
			adminData = {
				"role": selectData
			};
			try {
				await ApiService.modifyAdmin(adminData, id);
				closeHandle();
			} catch(error) {
				console.log('AdminList - handleEditRole - error :: ', error)
				setOpenWarning(true);
				setErrorMsg(error.response.data.message);
			} finally {
				getData();
			}
		}
	}

	const handleDelete = async () => {
		try {
			await ApiService.deleteAdmin(clickItem);
		} catch(error) {
			console.log('AdminList - handleDelete - error :: ', error)
			setOpenWarning(true);
			setErrorMsg(error.response.data.message);
		} finally {
			alertCloseHandle();
			getData();
		}
	}

  	return (
		<div className="adminList">
			{
				( role !== true ) ? (
					<Warning
						open={openWarning}
						onHideWarning={closeWarning}
						warningMsg={'해당 메뉴에 대한 권한이 없습니다!'}
					></Warning>
				)
				: ( 
					<ThemeProvider theme={theme}>
						<BreadCrumbBar menu="관리자 관리" smenu="관리자 정보 조회"/>
						<div className="adminAdd">
							<Button variant="contained" startIcon={<PersonAddAlt1RoundedIcon />} onClick={handleOpen}>
								관리자 추가
							</Button>
						</div>
						<div className="gridItem">
							{ loading && (<CircularProgress sx={{ position: 'absolute', top: '50%', left: '50%'}}/>) 
							}
							<DataGrid
								sx={{
									'.MuiDataGrid-columnHeaderTitle': { 
										fontWeight: 'bold',
									},
								}}
								hideFooterPagination={true}
								columnHeaderHeight={35}
								rowHeight={23}
								rows={data}
								columns={columns}
								autoHeight={true}
								disableSelectionOnClick
								disableColumnMenu={true}
							/>
						</div>

						<Dialog open={open} onClose={closeHandle} aria-labelledby="form-dialog-title" sx={{ height: '800px'}}>
							<DialogTitle id="form-dialog-title">{modify ? "관리자 정보 수정" : "관리자 정보 등록"}</DialogTitle>
							<DialogContent>
								<TextField
									label="Email"
									maxRows={4}
									defaultValue={userId}
									sx={{ width: "550px", mb: 3, mt:2}}
									disabled={modify ? true : false}
									onChange={handleChangeUserId}
									variant="outlined"
									InputLabelProps={{
										shrink: true,
									}}
									placeholder="이메일을 입력하세요."
								/>
								<TextField
									label="Password"
									maxRows={4}
									sx={{ width: "550px", mb: 3}}
									defaultValue={password}
									onChange={handleChangePassword}
									type="password"
									variant="outlined"
									InputLabelProps={{
										shrink: true,
									}}
									placeholder="비밀번호를 입력하세요."
								/>
								<TextField
									label="Confirm Password"
									maxRows={4}
									sx={{ width: "550px", mb: 3}}
									defaultValue={confirmPassword}
									onChange={handleChangeConfirmPassword}
									type="password"
									variant="outlined"
									InputLabelProps={{
										shrink: true,
									}}
									placeholder="비밀번호 확인(다시입력)"
								/>
								{ modify ? (
									<Autocomplete
										sx={{ width: "550px"}}
										onChange={(e, value) => {return setAuthList(value)}}
										multiple
										options={RoleData.map((data) => {
											return data.label
										})}
										getOptionLabel={(option) => option}
										// defaultValue={authList}
										value={authList}
										filterSelectedOptions
										renderInput={(params) => (
											<TextField
												{...params}
												variant="outlined"
												label="Role"
												placeholder="권한을 선택하세요."
											/>
										)}
									/>		
									) : (
										<Autocomplete
											sx={{ width: "550px"}}
											onChange={(e, value) => {return setAuthList(value)}}
											multiple
											options={RoleData.map((data) => {
												return data.label
											})}
											getOptionLabel={(option) => option}
											//defaultValue={[authList[0]]}
											filterSelectedOptions
											renderInput={(params) => (
											<TextField
												{...params}
												variant="outlined"
												label="Role"
												placeholder="권한을 선택하세요."
											/>
											)}
										/>
									)
								}	
							</DialogContent>
							<DialogActions sx={{ pr: '25px', mt: 1, mb: 3}}>
								<Button onClick={closeHandle} sx={{ backgroundColor: '#999999', color:"#FFFFFF", '&:hover': { backgroundColor: '#999999'}}} >취소</Button>	
								{
									modify ? (
										<Button onClick={handleEdit} variant="contained">
											수정
										</Button>	
									) : (
										<Button onClick={handleInsert} variant="contained">
											등록
										</Button>	
									)
								}	
							</DialogActions>	
						</Dialog>

						<Warning
							open={openWarning}
							onHideWarning={closeWarning}
							warningMsg={errorMsg}
						></Warning>

						<Delete 
							openDelete={alertOpen}
							closeDelete={alertCloseHandle}
							onClickDelete={handleDelete}
						/>
					</ ThemeProvider>
				)
			}
		</div>
  	)
}
